import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "error-msg-wrap" }
const _hoisted_2 = { class: "form-wrapper slide-up" }
const _hoisted_3 = { class: "form-close" }
const _hoisted_4 = { style: {"margin":"0 0 2px"} }
const _hoisted_5 = { style: {"font-size":"12px","color":"#a8a4a0","margin-bottom":"14px"} }
const _hoisted_6 = {
  key: 0,
  class: "chk-weekly"
}
const _hoisted_7 = { class: "chk-weekly-head" }
const _hoisted_8 = {
  key: 0,
  class: "playbook-process checklist-text-block"
}
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = { key: 0 }
const _hoisted_11 = {
  key: 0,
  class: "chk-missed"
}
const _hoisted_12 = {
  key: 1,
  class: "chk-oneoff"
}
const _hoisted_13 = { class: "chk-oneoff-head" }
const _hoisted_14 = { style: {"margin":"0"} }
const _hoisted_15 = {
  key: 0,
  class: "chk-missed"
}
const _hoisted_16 = {
  key: 0,
  class: "playbook-process checklist-text-block",
  style: {"margin":"20px 0"}
}
const _hoisted_17 = ["innerHTML"]
const _hoisted_18 = { style: {"margin":"0"} }
const _hoisted_19 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_svg_icon = _resolveComponent("svg-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("button", {
          type: "button",
          class: "form-close-x",
          title: "Close",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
        }, "×")
      ]),
      _createElementVNode("h4", _hoisted_4, _toDisplayString(_ctx.entry.userName), 1),
      _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.dateLabel) + " · " + _toDisplayString(_ctx.entry.done) + "/" + _toDisplayString(_ctx.entry.total) + " items completed", 1),
      (_ctx.parsed.weeklyItems.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_svg_icon, { icon: "calendar" }),
              _cache[1] || (_cache[1] = _createTextVNode("Weekly Items", -1))
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.parsed.weeklyItems, (item, i) => {
              return (_openBlock(), _createElementBlock("div", {
                key: 'w'+i
              }, [
                (item.type == 'textblock')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                      _createElementVNode("div", {
                        innerHTML: item.text
                      }, null, 8, _hoisted_9)
                    ]))
                  : (_openBlock(), _createElementBlock("div", {
                      key: 1,
                      class: _normalizeClass(["chk-item ro", { on: item.checked }])
                    }, [
                      _createElementVNode("div", null, [
                        _createElementVNode("b", null, [
                          _createTextVNode(_toDisplayString(item.label), 1),
                          (item.description)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_10, ":"))
                            : _createCommentVNode("", true)
                        ]),
                        _cache[2] || (_cache[2] = _createTextVNode(" ", -1)),
                        _createElementVNode("span", null, _toDisplayString(item.description), 1),
                        (item.carriedFromLabel)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_11, "Missed " + _toDisplayString(item.carriedFromLabel), 1))
                          : _createCommentVNode("", true)
                      ])
                    ], 2))
              ]))
            }), 128))
          ]))
        : _createCommentVNode("", true),
      (_ctx.parsed.oneOffItems.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _createVNode(_component_svg_icon, { icon: "plus" }),
              _cache[3] || (_cache[3] = _createTextVNode("One-Off Items", -1))
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.parsed.oneOffItems, (item, i) => {
              return (_openBlock(), _createElementBlock("div", {
                key: 'o'+i,
                class: _normalizeClass(["chk-item ro", { on: item.checked }])
              }, [
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("b", null, _toDisplayString(item.label), 1),
                  (item.carriedFromLabel)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_15, "Missed " + _toDisplayString(item.carriedFromLabel), 1))
                    : _createCommentVNode("", true)
                ])
              ], 2))
            }), 128))
          ]))
        : _createCommentVNode("", true),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.parsed.items, (item, i) => {
        return (_openBlock(), _createElementBlock("div", {
          key: 'i'+i
        }, [
          (item.type == 'textblock')
            ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                _createElementVNode("div", {
                  style: {"margin":"0"},
                  innerHTML: item.text
                }, null, 8, _hoisted_17)
              ]))
            : (_openBlock(), _createElementBlock("div", {
                key: 1,
                class: _normalizeClass(["chk-item ro", { on: item.checked }])
              }, [
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("b", null, [
                    _createTextVNode(_toDisplayString(item.label), 1),
                    (item.description)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_19, ":"))
                      : _createCommentVNode("", true)
                  ]),
                  _cache[4] || (_cache[4] = _createTextVNode(" ", -1)),
                  _createElementVNode("span", null, _toDisplayString(item.description), 1)
                ])
              ], 2))
        ]))
      }), 128))
    ])
  ]))
}